// @flow
import React from 'react'
import { VerticalCol, VerticalRow } from '../utils/Grid'
import WidgetContainer from '../containers/WidgetContainer'
import GamesBox from '../boxes/GamesBox'
import utmLinkGenerator from '../utils/UTMLinkGenerator'
import { type GamesWidgetProps } from './Types'

declare var UNVERSIONED_STATICS_PATH: string

export default (props: GamesWidgetProps) => {
  const {
    isOpening,
    widget,
    widget: {
      boxes,
      imageSize = '4_3',
      utmMedium
    }
  } = props

  if (!boxes.length) {
    return null
  }

  return (
    <WidgetContainer widget={widget} isOpening={isOpening}>
      <VerticalRow>
        {
          boxes.map(box => {
            const {
              guid,
              images,
              link,
              source,
              title
            } = box

            const image = `${UNVERSIONED_STATICS_PATH}${images[imageSize]}`

            const utmLink = utmLinkGenerator.createLink(link, {
              utmMedium,
              utmTerm: `position-${boxes.indexOf(box)}`,
              utmCampaign: source
            })

            return (
              <VerticalCol key={guid}>
                <GamesBox
                  image={image}
                  imageClass={`image-${imageSize}`}
                  link={utmLink}
                  title={title}
                />
              </VerticalCol>
            )
          })
        }
      </VerticalRow>
    </WidgetContainer>
  )
}
